<template>
  <div>
    <Logo></Logo>
    <Header></Header>
    <div class="banner">
      <Carousel></Carousel>
    </div>
    <div class="main-content">
      <router-view></router-view>
    </div>
    <div style="clear: left">
      <Footer></Footer>
    </div>
  </div>
</template>
<script>
import Logo from "./components/public/Logo.vue";
import Header from "./components/public/Header.vue";
import Carousel from "./components/public/Carousel.vue";
import Footer from "./components/public/Footer.vue";
export default {
  components: {
    Logo: Logo,
    Header: Header,
    Carousel: Carousel,
    Footer: Footer,
  },
};
</script>
<style lang="scss">
.main-content {
  width: 1300px;
  margin: auto;
}
.main {
  margin: 30px 0 30px 0;
}
.content {
  width: 970px;
  margin: 0 10px 30px 10px;
  padding: 0 40px;
  float: left;
  background-color: #f5f6fa !important;
}
.sidebar {
  width: 240px;
  height: 200px;
  margin: 0 40px 30px 0;
  float: left;
  background-color: #97aabd !important;
  .nav-item {
    font-size: 16px;
    font-weight: bold;
    background-color: #557a95;
    border: #ccc 1px solid;
    border-radius: 0;
    .nav-link {
      margin: 0;
      padding: 0;
      a {
        padding: 0.5rem 1rem;
        color: #f5f6fa !important;
        display: block;
      }
      .active {
        background-color: #931b22 !important;
      }
    }
    span {
      margin-right: 10px;
    }
  }
}
.banner {
  min-width: 1300px;
}
ol{
  margin-bottom: 5px;
}
.carousel-indicators {
  bottom: -25px;
}
.carousel-indicators li {
  background-color: #000;
}
.carousel-caption {
  padding: 0 10px;
  bottom: 0;
  right: 0%;
  left: 0%;
  background-color: #00000050;
  h3 {
    padding: 0;
    margin: 10px;
    text-align: center;
    font-weight: bold;
    font-size: 16px;
    color: #fff;
    border: none;
  }
  p {
    font-weight: bold;
    font-size: 16px;
    color: #fff;
  }
}
.footer {
  min-width: 1300px;
}
.card {
  border-radius: 0em !important;
  .card-title {
    font-size: 16px;
  }
  .card-text {
    font-size: 16px;
  }
}
.card-img-left,
.card-img-top,
.card-img-right,
.card-img-bottom {
  border-radius: 0em !important;
}
</style>
